var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.men.list == true)?_c('screen-list',{on:{"item":_vm.menu}}):_vm._e(),(_vm.men.info == true)?_c('screen-info',{on:{"item":_vm.menu}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }